// Player Account & Cloud Progress System
// Supports Guest mode (default) and registered player accounts with saved progress

const ACCOUNTS_KEY = 'slimeduel.accounts';
const CURRENT_ACCOUNT_KEY = 'slimeduel.current_account';

export function getStoredAccounts() {
  try {
    return JSON.parse(localStorage.getItem(ACCOUNTS_KEY) || '{}');
  } catch (e) {
    return {};
  }
}

export function getCurrentUser() {
  try {
    return localStorage.getItem(CURRENT_ACCOUNT_KEY) || null;
  } catch (e) {
    return null;
  }
}

export function registerAccount(username, password) {
  username = (username || '').trim().toLowerCase();
  if (!username || username.length < 3) throw new Error('Username must be at least 3 characters');
  if (!password || password.length < 4) throw new Error('Password must be at least 4 characters');

  const accounts = getStoredAccounts();
  if (accounts[username]) throw new Error('An account with this username already exists');

  let currentProf = {};
  try {
    currentProf = JSON.parse(localStorage.getItem('slimeduel.profile') || '{}');
  } catch (e) {}

  const displayName = username.charAt(0).toUpperCase() + username.slice(1);
  const newProfile = {
    ...currentProf,
    name: displayName,
    coins: Number.isInteger(currentProf.coins) ? currentProf.coins : 1500,
    inventory: Array.isArray(currentProf.inventory) ? currentProf.inventory : ['shooter']
  };

  accounts[username] = {
    username,
    displayName,
    password,
    createdAt: Date.now(),
    progress: newProfile
  };

  localStorage.setItem(ACCOUNTS_KEY, JSON.stringify(accounts));
  localStorage.setItem(CURRENT_ACCOUNT_KEY, username);
  localStorage.setItem('slimeduel.profile', JSON.stringify(newProfile));
  return accounts[username];
}

export function loginAccount(username, password) {
  username = (username || '').trim().toLowerCase();
  const accounts = getStoredAccounts();
  const acc = accounts[username];
  if (!acc || acc.password !== password) throw new Error('Invalid username or password');

  localStorage.setItem(CURRENT_ACCOUNT_KEY, username);
  if (acc.progress) {
    localStorage.setItem('slimeduel.profile', JSON.stringify(acc.progress));
  }
  return acc;
}

export function logoutAccount() {
  saveCloudProgress();
  localStorage.removeItem(CURRENT_ACCOUNT_KEY);
}

export function saveCloudProgress() {
  const current = getCurrentUser();
  if (!current) return;
  const accounts = getStoredAccounts();
  if (!accounts[current]) return;

  try {
    const prof = JSON.parse(localStorage.getItem('slimeduel.profile') || '{}');
    accounts[current].progress = { ...accounts[current].progress, ...prof };
    localStorage.setItem(ACCOUNTS_KEY, JSON.stringify(accounts));
  } catch (e) {}
}
